import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { axiosGet } from '../util/api'
import { setCurrentProfile } from '../actions/user'
import type { State } from '../reducers'
import { KeywordsTree } from '../components/trees/KeywordsTree'
import { isEmpty } from '../util/helpers'
import { Spinner } from '@blueprintjs/core'
import { Layout } from '../components/Layout'
import { EmptyState } from '../components/ui/empty-state'
import { TargetsTree } from '../components/trees/TargetsTree'
import { DataType } from '../types/keywords_tree'
import { type EntityId, idKey } from '../types/constants'

export const DryRun = () => {
    const [data, setData] = useState<DataType>()
    const { promotion_id } = useParams()
    const [loading, setLoading] = useState(true)
    const dispatch = useDispatch()
    const profile = useSelector<State, EntityId | null>((state) => state.user.profile)

    useEffect(() => {
        axiosGet(`promotions/${promotion_id}/dry-run`)
            .then((res) => {
                setLoading(false)
                setData(res.data)

                const promotionProfile = res.data.profile_id as EntityId
                if (promotionProfile && idKey(promotionProfile) !== idKey(profile)) {
                    dispatch(setCurrentProfile(promotionProfile))
                }
            })
            .catch(() => {
                setLoading(false)
            })
    }, [])
    return (
        <Layout primary="Dry Run">
            {loading && (
                <EmptyState
                    className="mt-24"
                    title="Loading..."
                    description={
                        <div>
                            <div>This can take a few seconds</div>
                            <Spinner className="mt-8" size={80} />
                        </div>
                    }
                />
            )}
            {data != undefined && !isEmpty(data) && (
                <div className="text-left">
                    <KeywordsTree
                        title={`Creating ${data?.created?.keywords.count} new keywords`}
                        data={data?.created?.keywords}
                    />
                    <br />
                    <KeywordsTree
                        bid={false}
                        title={`Creating ${data?.created?.negative_keywords.count} new negative keywords`}
                        data={data?.created?.negative_keywords}
                    />
                    <br />
                    <KeywordsTree
                        showAdGroup={false}
                        bid={false}
                        title={`Creating ${data?.created?.campaign_negative_keywords.count} new campaign negative keywords`}
                        data={data?.created?.campaign_negative_keywords}
                    />
                    <br />
                    <TargetsTree
                        title={`Creating ${data?.created?.targets?.count} new targets`}
                        data={data?.created?.targets}
                    />
                    <br />
                    <TargetsTree
                        bid={false}
                        title={`Creating ${data?.created?.negative_targets?.count} new negative targets`}
                        data={data?.created?.negative_targets}
                    />
                    <br />
                </div>
            )}
        </Layout>
    )
}
